import { PecDTO } from "@app/shared/dto/anagrafe/pecDTO";
import { CartaceoVO } from "./cartaceoVO";
import { PecVO } from "./pecVO";

export class CreaRecapitoVO {
  cartaceo: CartaceoVO;
  pec: PecVO = new PecVO();
}
